<template>
<transition name="modal">
    <div class="modal-mask">
        <div class="modal-wrapper" @click.stop="click">
            <div class="modal-container" @click.stop="none">
                <div class="modal-body">
                    <progress-q></progress-q>
                    <h2 class="center">Caricamento...</h2>
                </div>
                <div class="modal-footer">
                    <slot name="footer">
                    </slot>
                </div>
            </div>
        </div>
    </div>
</transition>
</template>

<script>
import ProgressQ from '../backend/ProgressQ'
export default {
  name: 'ModalQ',
  components: {
    ProgressQ
  },
  methods: {
    click: function() {
      this.$emit('click')
    },
    none: function() {
      // serve per prevenire la chiusura del modale se clicco nel dialog
    }
  }
}
</script>

<style scoped>
.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: block;
  transition: opacity 0.3s ease;
}

.modal-wrapper {
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 100%;
}

.modal-container {
  overflow: auto;
  width: auto;
  margin: 0px auto;
  background-color: transparent;
  border-radius: 2px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
  transition: all 0.3s ease;
}

.modal-header h3 {
  margin-top: 0;
  color: #42b983;
}

.modal-body {
  margin: 0 0;
  background-color: whitesmoke;
}

.modal-default-button {
  float: right;
}

/*
    * The following styles are auto-applied to elements with
    * transition="modal" when their visibility is toggled
    * by Vue.js.
    *
    * You can easily play with the modal transition by editing
    * these styles.
    */

.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}

@media screen and (min-width: 720px) {
  .modal-container {
    width: 600px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/utils/ModalQ.vue